module.exports = __webpack_public_path__ + "img/thankyou_hero_mobile.2b2463b9.jpg";